<template lang="pug">
  div(@click="showDropdown = true"
  v-click-outside="hideDropdown")
    div
      span#mathquill(:class="$style.mathQuill" ref="mathQuill" @keyup.enter="onEnterPressed" tabIndex=0) {{ value }}
    math-quill-symbols(
      :show="showSymbols && showDropdown"
      :custom-symbols="customSymbols"
      @math-masked-token="onMathMaskedTokenClick"
      @math-operator="onMathOperatorClick"
      @custom-token="customTokenClick"
    )
</template>

<script>
  import MathQuillSymbols from './MathQuillSymbols'

  let latexTable = []

  export default {
    components: {
      MathQuillSymbols,
    },

    props: {
      value: {
        type: String,
        default: '',
      },
      showSymbols: {
        type: Boolean,
        default: true,
      },
      customSymbols: {
        type: Array,
        default: () => [],
      },
    },

    data() {
      return {
        mathField: null,
        rowId: null,
        showDropdown: false,
      }
    },

    watch: {
      value(val) {
        if (val === '' && this.mathField) {
          this.mathField.latex('')
          latexTable = []
        }
      },
    },

    mounted() {
      const { MQ } = window
      const self = this
      const temp = Math.random().toString().replace('.', '')
      this.rowId = temp.substring(1, 8)

      MQ.config({
        spaceBehavesLikeTab: true,
        leftRightIntoCmdGoes: 'up',
        restrictMismatchedBrackets: true,
        sumStartsWithNEquals: true,
        supSubsRequireOperand: true,
        charsThatBreakOutOfSupSub: '+-=<>',
        autoSubscriptNumerals: false,
        autoCommands: 'pi theta sqrt sum',
        autoOperatorNames: 'sin cos tan exp inf',
      })

      MQ.registerEmbed('container', (id) => {
        const latex = self.getLatex(id)
        const html = `<span class="math-container" id="math-container-${id}">${latex}</span>`
        return {
          htmlString: html,
          latex() { return latex },
          text() { return latex },
        }
      })

      MQ.registerEmbed('maskedContainer', (id) => {
        const maskPair = self.getLatex(id)
        const [displayLatex, evalLatex] = maskPair

        const html = `<span class="math-container" id="math-container-${id}">${displayLatex}</span>`
        return {
          htmlString: html,
          latex() { return evalLatex },
          text() { return evalLatex },
        }
      })

      this.mathField = new window.MQ.MathField(this.$refs.mathQuill, {
        handlers: {
          edit: () => {
            this.$emit('input', this.mathField.latex())
          },
        },
      })
    },

    beforeDestroy() {
      this.mathField = null
    },

    methods: {
      hideDropdown() {
        this.showDropdown = false
      },

      onEnterPressed() {
        this.showDropdown = false
        this.$emit('onMathInputEnter')
      },

      onMathOperatorClick(val) {
        this.mathField.cmd(val)
        this.$refs.mathQuill.querySelector('textarea').focus()
      },
      onMathMaskedTokenClick(val) {
        const id = this.setLatex(val)
        const rowId = this.rowId.concat(id)
        this.mathField.write(`\\embed{maskedContainer}[${rowId}]`)
        window.MQ.StaticMath(document.getElementById(`math-container-${rowId}`))
        this.mathField.focus()
      },
      customTokenClick(val) {
        const id = this.setLatex(val)
        const rowId = this.rowId.concat(id)
        this.mathField.write(`\\embed{container}[${rowId}]`)
        window.MQ.StaticMath(document.getElementById(`math-container-${rowId}`))
        this.mathField.focus()
      },
      getLatex(id) {
        const arrayId = id.substring(7, id.length)
        return latexTable[arrayId]
      },
      setLatex(latex) {
        const id = latexTable.length
        latexTable.push(latex)
        return id
      },
    },
  }
</script>

<style module>
  #mathquill {
    width: 95%;
    /*height: 40px;*/
    font-size: 16px;
    padding: 8px 15px 8px;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    background-color: #fff;
  }

  
</style>

<style>
  .math-container .mq-cursor {
    display: none !important;
  }
</style>
